import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { config } from "../../../../src/config/global";
import { getTokenExpiredDataPending, getTokenExpiredDataSuccess, getTokenExpiredDataFailure, getClearCookiesRequest, getClearCookiesSuccess, getClearCookiesFailure } from "../slice/tokenExpiredSlice";
const Token_Expired = config?.TOKEN_EXPIRED;
const fetchLoginData = async () => {
  let data = {
    mode: "no-cors",
    headers: {
      "App-Authorization": "accesstoken",
      "source": "website"
    },
    loader: true
  };
  const response = await api.get(Token_Expired, data);
  sessionStorage.setItem("temptoken", response.headers.accesstoken);
  return response;
};
function* getLoginData(action) {
  try {
    const response = yield call(api.get, Token_Expired);
    const refreshTokenValues = {
      ...response?.headers
    };
    yield put(getTokenExpiredDataSuccess(refreshTokenValues));
  } catch (error) {
    yield put(getTokenExpiredDataFailure(error));
  }
}
function* getClearCookies() {
  try {
    const response = yield call(api.get, config?.COMMON_CACHE_FILTERED_COOKIE);
    yield put(getClearCookiesSuccess(response?.data));
  } catch (error) {
    yield put(getClearCookiesFailure(error?.message));
  }
}
export function* watchTokenExpiredData() {
  yield takeLatest(getTokenExpiredDataPending.type, getLoginData);
}
export function* watchGetClearCookies() {
  yield takeLatest(getClearCookiesRequest.type, getClearCookies);
}